import { defineMessages } from 'utils/intl';

export default defineMessages({
  availableNow: 'Wysyłka w 24h',
  availableFrom: 'Dostępny od {date}',
  closestShipping: 'Najbliższa dostawa za {days} dni',
  askForAvailability: 'Zapytaj o dostępność',
  eolProduct: 'Produkt niedostępny (EOL)',
  prereleaseProduct: 'Produkt przedpremierowy',
});
